import { FC } from 'react';

import { Modal } from '../../../../components/modal/index';
import { popupStore } from './popup.store';

export const ActivatePerkPopup: FC = () => {
  const isOpen = popupStore(({ open }) => open);

  const handleAccept = popupStore(({ handleAccept }) => handleAccept);
  const handleDismiss = popupStore(({ handleDismiss }) => handleDismiss);

  return (
    <Modal
      description="Are you sure you want to activate this perk? The perk will be added to the landing page and the app. You can deactivate this perk later."
      dismissButtonContent="Cancel"
      isOpen={isOpen}
      onDismiss={handleDismiss}
      onSuccess={handleAccept}
      successButtonClassName="bg-brand-700"
      successButtonContent="Activate"
      title="Activate Perk"
    />
  );
};
